import { camelCaseToTitle } from "../../../../../../../helpers/StringHelper";

export const mapData = ({
  data,
  setDaily,
  setWeekly,
  setMonthly,
}) => {
  const dailyData = [];
  const weeklyData = [];
  const monthlyData = [];

  Object.keys(data.pastMonth).reverse().forEach((key) => {
    let prevValue = 0;
    for (const [type, value] of Object.entries(data.pastMonth[key])) {
      prevValue += value;
      dailyData.push({ type, value: prevValue, series: `${camelCaseToTitle(key)}`, realValue: value });
    }
  });

  Object.keys(data.past3Months).reverse().forEach((key) => {
    let prevValue = 0;
    for (const [type, value] of Object.entries(data.past3Months[key])) {
      prevValue += value;
      weeklyData.push({ type, value: prevValue, series: `${camelCaseToTitle(key)}`, realValue: value });
    }
  });

  Object.keys(data.past12Months).reverse().forEach((key) => {
    let prevValue = 0;
    for (const [type, value] of Object.entries(data.past12Months[key])) {
      prevValue += value;
      monthlyData.push({ type, value: prevValue, series: `${camelCaseToTitle(key)}`, realValue: value });
    }
  });

  setDaily(dailyData);
  setWeekly(weeklyData);
  setMonthly(monthlyData);
}

